<template>
	<div class="container__shapefileupload">
		<div class="container__shapefileupload__fileuploadareas">
			<div v-show="showFzda">
				<FileUpload
					:key="gerarChaveAleatoria()"
					ref="ref_component_fileupload_fzda"
					has-file-icon="fas fa-draw-polygon"
					extensions-accepted=".zip"
					:label="$t('farmShapeImport')"
					:has-file-in-back-end="getFzdaHasFileInDB"
					@onUpload="loadFzdaShape"
				/>
			</div>
			<div v-show="showTlho">
				<FileUpload
					:key="gerarChaveAleatoria()"
					ref="ref_component_fileupload_tlho"
					has-file-icon="fas fa-draw-polygon"
					extensions-accepted=".zip"
					:label="$t('sectionShapeImport')"
					:disabled="!getFzdaHasFileInDB"
					:has-file-in-back-end="getTlhoHasFileInDB"
					@onUpload="loadTlhoShape"
				/>
			</div>
			<div v-show="showPltio">
				<FileUpload
					:key="gerarChaveAleatoria()"
					ref="ref_component_fileupload_ptio"
					has-file-icon="fas fa-draw-polygon"
					extensions-accepted=".zip"
					:label="$t('plantationShapeImport')"
					:disabled="!getTlhoHasFileInDB"
					:has-file-in-back-end="getPtioHasFileInDB"
					@onUpload="loadPtioShape"
				/>
			</div>
			<div v-show="showPrcla">
				<FileUpload
					:key="gerarChaveAleatoria()"
					ref="ref_component_fileupload_prcla"
					has-file-icon="fa-draw-polygon"
					extensions-accepted=".zip"
					:label="$t('plotShapeImport')"
					:disabled="false"
					:has-file-in-back-end="getPrclaHasFileInDB"
					@onUpload="loadPrclaShape"
				/>
			</div>
		</div>
		<div
			v-if="mostrarImportar"
			class="container__shapefileupload__button"
		>
			<Button
				:label="$t('import')"
				semantic-class="mini"
				:disabled="disabled"
				width-auto
				@click="$emit('click')"
			/>
		</div>
	</div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

import Button from '../../../../../../components/Button/Button'
import FileUpload from '../../../../../../components/FileUpload/FileUpload'
import * as turf from '@turf/turf'
import { ZipFileToGeoJson } from '../../../../../../utils/MapFunctions'

import { mapGetters, mapMutations } from 'vuex'

export default {
	components: { Button, FileUpload },

	computed: {
		...mapGetters('moduleImportShape', [
			'getGeoJsonFzda',
			'getGeoJsonTlho',
			'getGeoJsonPtio',
			'getFzdaHasFileInDB',
			'getTlhoHasFileInDB',
			'getPtioHasFileInDB',
			'getPrclaHasFileInDB',
		]),

		disabled() {
			return !(this.isBtnImportEnabled && this.buttonEnabled)
		},
	},

	data() {
		return {
			/**
			 * Verifica se o botão para importar está habilitado
			 */
			isBtnImportEnabled: false,
		}
	},

	methods: {
		...mapMutations([
			'moduleImportShape/setGeoJsonFzda',
			'moduleImportShape/setFzdaHasFileInDB',
			'moduleImportShape/setGeoJsonTlho',
			'moduleImportShape/setGeoJsonPrcla',
			'moduleImportShape/setGeoJsonPtio',
			'moduleImportShape/setTempGeoJson',
			'moduleImportShape/setBounds',
			'moduleMessages',
			['mutationShowMessage'],

			'moduleMapData/mutationSetColumns',

			'moduleMessages/mutationShowMessage',
		]),

		gerarChaveAleatoria() {
			return uuidv4()
		},

		/**
		 * Carrega o shape de fazenda do arquivo zip no mapa
		 */
		async loadFzdaShape(file) {
			const geojson = await ZipFileToGeoJson(file)
			console.log('🚀 ~ file: ShapeFileUpload.vue ~ line 96 ~ loadFzdaShape ~ geojson', geojson)

			this['moduleImportShape/setGeoJsonFzda']({
				coordinates: geojson.features[0].geometry.coordinates,
				bbox: geojson.features[0].geometry.bbox,
				type: geojson.features[0].geometry.type,
				properties: geojson.features[0].properties,
				geojson,
			})

			this['moduleImportShape/setBounds'](geojson.features[0].geometry.bbox)
			this.isBtnImportEnabled = true
		},

		/**
		 * Carrega o ponto de parcela
		 */
		async loadPrclaShape(file) {
			const geojson = await ZipFileToGeoJson(file)
			let geojsonPtioList = this.organizeGeoJsonData(geojson)
			const columns = []
			let points = geojsonPtioList.map((item) => {
				return {
					type: 'Feature',
					geometry: item.geometry,
				}
			})

			points.forEach((point) => {
				if (!this.isInAnyPlantio(point)) {
					this['moduleMessages/mutationShowMessage']({
						messageTitle: this.$t('erro'),
						messageText: this.$t('erroUploadParcela'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
					// Atualiza geojsonPtioList para conter apenas os pontos dentro do plantio
					geojsonPtioList = geojsonPtioList.filter((item) => this.isInAnyPlantio(item))
				}
			})

			const idSet = new Set() // Usando um conjunto para verificar duplicatas
			const codPrlaSet = new Set() // Usando um conjunto para verificar duplicatas
			geojsonPtioList.forEach((feature) => {
				const codPrla = feature.properties.COD_PARCEL
				const id = feature.properties.ID
				delete feature.properties.existente

				if (typeof codPrla === 'string') {
					if (codPrlaSet.has(codPrla)) {
						alert(
							' Atenção !,Verifique o arquivo antes de salvar o planejamento código de parcela duplicado: ' +
								codPrla,
						)
					} else {
						codPrlaSet.add(codPrla)
						feature.properties.COD_PARCEL = codPrla
					}
				} else if (codPrla != null) {
					codPrla.toString()
					if (codPrlaSet.has(codPrlaSet)) {
						alert(
							' Atenção !,Verifique o arquivo antes de salvar o planejamento código de parcela duplicado: ' +
								codPrla,
						)
					} else {
						codPrlaSet.add(codPrlaSet.toString())
						feature.properties.COD_PARCEL = codPrla // Atualizando o valor para string no objeto // Adicionando ao conjunto se não for duplicado
					}
				}
				if (typeof id === 'string') {
					if (idSet.has(id)) {
						alert(
							' Atenção !,Verifique o arquivo antes de salvar o planejamento código de parcela duplicado: ' +
								id,
						)
					} else {
						idSet.add(id)
						feature.properties.COD_PARCEL = id
					}
				} else if (id != null) {
					id.toString()
					if (idSet.has(id)) {
						alert(
							' Atenção !,Verifique o arquivo antes de salvar o planejamento código de parcela duplicado: ' +
								id,
						)
					} else {
						idSet.add(id.toString())
						feature.properties.COD_PARCEL = id // Atualizando o valor para string no objeto // Adicionando ao conjunto se não for duplicado
					}
				}
			})

			Object.keys(geojson.features[0].properties).forEach((f) => {
				columns.push({ value: f, label: f })
			})

			this['moduleImportShape/setGeoJsonPrcla']({
				features: geojsonPtioList,
				geojson,
				bbox: geojson.features[0].geometry.bbox,
				type: geojson.features[0].geometry.type,
				properties: geojson.features[0].properties,
			})
			this['moduleMapData/mutationSetColumns'](columns)
			this.$emit('showMapPrcla')
			this.isBtnImportEnabled = true
		},

		isInAnyPlantio(point) {
			return this.getGeoJsonPtio.features.some((feature) =>
				turf.booleanPointInPolygon(point, feature),
			)
		},

		/**
		 * Carrega o shape de plantio
		 */
		async loadPtioShape(file) {
			const geojson = await ZipFileToGeoJson(file)
			const geojsonPtioList = this.organizeGeoJsonData(geojson)
			const columns = []

			Object.keys(geojson.features[0].properties).forEach((f) => {
				columns.push({ value: f, label: f })
			})

			this['moduleImportShape/setGeoJsonPtio']({
				features: geojsonPtioList,
				geojson,
				bbox: geojson.features[0].geometry.bbox,
				type: geojson.features[0].geometry.type,
				properties: geojson.features[0].properties,
			})
			this['moduleMapData/mutationSetColumns'](columns)
			this.$emit('showMapPtio')
			this.isBtnImportEnabled = true
		},

		/**
		 * Carrega o shape de plantio do arquivo zip no mapa
		 */
		async loadTlhoShape(file) {
			const geojson = await ZipFileToGeoJson(file)
			const geojsonTlhoList = this.organizeGeoJsonData(geojson)
			const columns = []

			Object.keys(geojson.features[0].properties).forEach((f) => {
				columns.push({ value: f, label: f })
			})

			this['moduleImportShape/setTempGeoJson'](this.getGeoJsonTlho)
			this['moduleImportShape/setGeoJsonTlho']({
				features: geojsonTlhoList,
				geojson,
				bbox: geojson.features[0].geometry.bbox,
				type: geojson.features[0].geometry.type,
				properties: geojson.features[0].properties,
			})
			this['moduleMapData/mutationSetColumns'](columns)
			this.isBtnImportEnabled = true

			this.$emit('showMapTlho')
		},

		/**
		 * Organiza os dados de geojson de talhao e plantio
		 */
		organizeGeoJsonData(geojson) {
			try {
				const geojsonList = []

				geojson.features.forEach((f) => {
					geojsonList.push({
						geometry: f.geometry,
						coordinates: f.geometry.coordinates,
						properties: f.properties,
						type: f.geometry.type,
					})
				})

				return geojsonList
			} catch (error) {
				let errorMessage = error.message
				alert('Ocorreu um erro ao organizar os dados do arquivo shape:' + errorMessage)
				return null
			}
		},

		/**
		 * Atualiza o shape de Fazenda
		 */
		updateFzdaShape() {
			/*const bodyData = {
        id: this.fzdaId,
        fzda_md_poligono: this.getGeoJsonFzda,
      };

      securityApi
        .put("/Fzda", bodyData)
        .then((response) => {
          const { message } = response.data;
          this.$refs.ref_component_fileupload_fzda.$data.hasFileInFrontEnd = false;
          this["moduleImportShape/setFzdaHasFileInDB"](true);
          this["moduleMessages/mutationShowMessage"]({
            messageTitle: "Importado com sucesso",
            messageText: message,
            messageIcon: "fas fa-draw-polygon",
            messageType: "success",
          });
        })
        .catch(() => {
          this["moduleMessages/mutationShowMessage"]({
            messageTitle: "Erro ao importar Shape",
            messageText: "Problemas na importação do shape",
            messageIcon: "fas fa-draw-polygon",
            messageType: "error",
          });
        });*/
		},
	},

	props: {
		/**
		 * Id da fazenda que está sendo importado os poligonos
		 */
		mostrarImportar: { type: Boolean, default: true },
		fzdaId: String,
		ordemServicoId: String,
		fkEstrato: String,
		tipoOS: String,
		showFzda: { type: Boolean, default: false },
		showTlho: { type: Boolean, default: false },
		showPltio: { type: Boolean, default: false },
		showPrcla: { type: Boolean, default: false },

		/**
		 * prop para receber booleando quando todas as propriedades obrigatórias forem mapeadas
		 */
		buttonEnabled: {
			type: Boolean,
			default: false,
		},
	},
}
</script>

<style>
.container__shapefileupload {
	display: flex;
	flex-direction: column;
	width: 100%;
}

.container__shapefileupload__fileuploadareas {
	margin: 0;
	width: 100%;
	/* justify-content: space-around; */
	flex-direction: row;
}

.container__shapefileupload__button {
	display: flex;
	justify-content: flex-end;
	margin-top: 0.5rem;
	margin-bottom: 0.5rem;
}
</style>
